import React from 'react';
import { RandomCssDemo } from './RandomCssDemo';
import { makeDivs } from './utils';
import PETAL_1 from './petals/1.png';
import PETAL_2 from './petals/2.png';
import PETAL_3 from './petals/3.png';
import PETAL_4 from './petals/4.png';
import PETALS_BG from './petals/bg.jpg';

const PETAL_HTML = makeDivs(40, 'petal');

const PETAL_SCAFFOLD = `
  * { box-sizing: border-box; }
  :root {
    --petal-1: url("${PETAL_1}");
    --petal-2: url("${PETAL_2}");
    --petal-3: url("${PETAL_3}");
    --petal-4: url("${PETAL_4}");
  }
  html {
    overflow: clip;
    min-height: 100vh;
  }
  body {
    margin: 0;
    min-height: 100vh;
    overflow: clip;
    background: url("${PETALS_BG}") center / cover no-repeat;
  }

  .petal {
    position: absolute;
    top: -40px;
    background: var(--bg, var(--petal-1)) no-repeat center / contain;
  width: random(30px, 50px);
  aspect-ratio: 1 / 1;
  translate: var(--initial-position) 0;
  transform-style: preserve-3d;
  }

.petal:nth-child(4n + 1) { --bg: var(--petal-1); }
.petal:nth-child(4n + 2) { --bg: var(--petal-2); }
.petal:nth-child(4n + 3) { --bg: var(--petal-3); }
.petal:nth-child(4n + 4) { --bg: var(--petal-4); }
`;

const FULL_PETAL_CSS = `
  ${PETAL_SCAFFOLD}
.petal {
  --initial-position: random(element-scoped, -40vw, 100vw);
  --end-position: calc(var(--initial-position) + random(20vw, 50vw));
  --rotx: random(-45deg, 45deg);
  --roty: random(-45deg, 45deg);


  animation:
    fall random(5s, 10s) linear infinite,
    rotate random(2s, 4s) linear infinite,
    grow random(2s, 4s) ease-in-out infinite alternate;
  animation-delay: random(-10s, 0s), random(-10s, 0s), random(-10s, 0s);
  transform-origin: top center;
}


@keyframes fall {
  to {
    translate: var(--end-position) calc(100vh + 100px);
  }
}

@keyframes grow {
  to {
    scale: random(1.5, 2);
  }
}

@keyframes rotate {
  from {
    transform: perspective(300px) rotateY(var(--roty)) rotateZ(-30deg) rotateX(var(--rotx));
  }
  to {
    transform: perspective(300px) rotateY(calc(var(--roty) + 360deg)) rotateZ(330deg)
      rotateX(calc(var(--rotx) + 360deg));
  }
}
`;

export function PetalsIntroExample() {
  return <RandomCssDemo title="Falling Petals" htmlBody={PETAL_HTML} scaffoldCss={FULL_PETAL_CSS} />;
}

export function PetalsFallingAnimationExample() {
  return (
    <RandomCssDemo
      title="Falling Petals: Fall Animation"
      htmlBody={PETAL_HTML}
      scaffoldCss={PETAL_SCAFFOLD}
      cssCodeInit={`.petal {
  --initial-position: random(element-scoped, -40vw, 100vw);
  --end-position: calc(var(--initial-position) + random(20vw, 50vw));

  translate: var(--initial-position) 0;
  animation: fall random(5s, 10s) linear infinite;
  animation-delay: random(-10s, 0s);
}

@keyframes fall {
  to {
    translate: var(--end-position) calc(100vh + 100px);
  }
}`}
    />
  );
}

export function PetalsTwirlExample() {
  return (
    <RandomCssDemo
      title="Falling Petals: Twirling"
      htmlBody={PETAL_HTML}
      scaffoldCss={PETAL_SCAFFOLD}
      cssCodeInit={`.petal {
  --initial-position: random(element-scoped, -40vw, 100vw);
  --end-position: calc(var(--initial-position) + random(20vw, 50vw));
  --rotx: random(-45deg, 45deg);
  --roty: random(-45deg, 45deg);

  translate: var(--initial-position) 0;

  animation:
    fall random(5s, 10s) linear infinite,
    rotate random(2s, 4s) linear infinite,
    grow random(2s, 4s) ease-in-out infinite alternate;
  animation-delay: random(-10s, 0s), random(-10s, 0s), random(-10s, 0s);
  transform-origin: top center;
}

@keyframes fall {
  to {
    translate: var(--end-position) calc(100vh + 100px);
  }
}

@keyframes grow {
  to {
    scale: random(1.5, 2);
  }
}

@keyframes rotate {
  from {
    transform: perspective(300px) rotateY(var(--roty)) rotateZ(-30deg) rotateX(var(--rotx));
  }
  to {
    transform: perspective(300px) rotateY(calc(var(--roty) + 360deg)) rotateZ(330deg)
      rotateX(calc(var(--rotx) + 360deg));
  }
}`}
    />
  );
}
